import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Flex } from "styled-system/jsx";
import { UpdateProfileFormValues } from "../../useUpdateProfileForm";
import {
  ControlledSelectRoot,
  SelectBusinessTypeTags,
} from "shared/components";
import { businessTypeOptions } from "shared/constants";
import { Select } from "@ttc3k/trekker";
import { EnumTagGroupKey } from "gql/generated";

export const BusinessInfo = () => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<UpdateProfileFormValues>();

  const businessType = useWatch({ control, name: "businessType" });
  const businessTypeTags = useWatch({ control, name: "businessTypeTags" });

  const handleSelectBusinessType = (businessType: string) => {
    setValue("businessType", businessType, { shouldDirty: true });
    setValue("businessTypeTags", [], { shouldDirty: true });
  };
  const handleSelectBusinessTypeTag = (tagId: string) => {
    const isRemovingTag = businessTypeTags.includes(tagId);

    const newBusinessTypeTags = isRemovingTag
      ? [...businessTypeTags].filter((tag) => tag !== tagId)
      : [...businessTypeTags, tagId];

    setValue("businessTypeTags", newBusinessTypeTags, { shouldDirty: true });
  };
  return (
    <Flex flexDir={"column"} gap={"200"}>
      <ControlledSelectRoot
        name={"businessType"}
        items={businessTypeOptions}
        value={[businessType]}
        label={t(
          "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.BUSINESS_TYPE.TITLE",
        )}
        placeholder={t(
          "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.BUSINESS_TYPE.PLACEHOLDER",
        )}
        onValueChange={({ value }: { value: string[] }) =>
          handleSelectBusinessType(value[0])
        }
      >
        {businessTypeOptions.map((businessTypeOpt) => (
          <Select.Item key={businessTypeOpt.value} item={businessTypeOpt} />
        ))}
      </ControlledSelectRoot>
      <SelectBusinessTypeTags
        currentBusinessType={businessType as EnumTagGroupKey}
        onSelectTag={handleSelectBusinessTypeTag}
        selectedTags={businessTypeTags}
      />
    </Flex>
  );
};
